module.exports = __webpack_public_path__ + "img/img_product3.73e2ba8a.png";